import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './TermsConditions.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    loadPrivacyPolicy();
  }, []);

  const loadPrivacyPolicy = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: 'admin/settings'
      });

      if (response.data.status && response.data.data) {
        const privacyPolicy = response.data.data.privacy_policy || '';
        setContent(privacyPolicy);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Error loading privacy policy:', error);
      toast.error('Failed to load privacy policy');
      setIsLoader(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const response = await ApiService.request({
        method: 'PUT',
        url: 'admin/settings',
        data: {
          privacy_policy: content
        }
      });

      if (response.data.status) {
        toast.success('Privacy Policy saved successfully!');
      } else {
        toast.error(response.data.message || 'Failed to save');
      }
      setSaving(false);
    } catch (error) {
      console.error('Error saving privacy policy:', error);
      toast.error('Failed to save privacy policy');
      setSaving(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['clean']
    ],
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'color', 'background', 'align'
  ];

  if (isLoader) {
    return <Loader />;
  }

  return (
    <div className="d-flex flex-column flex-column-fluid">
      {/* Header */}
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <div className="d-flex align-items-center">
              <button 
                className="btn btn-icon btn-sm btn-light me-3"
                onClick={handleBack}
              >
                <i className="bi bi-arrow-left"></i>
              </button>
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                Privacy Policy
              </h1>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <button 
              className="btn btn-base"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div id="kt_app_content" className="app-content flex-column-fluid pt-0">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label fw-bold">Privacy Policy Content</label>
                <p className="text-muted small">Edit the privacy policy content using the rich text editor below.</p>
              </div>
              <div className="terms-editor-container">
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={setContent}
                  modules={modules}
                  formats={formats}
                  placeholder="Enter privacy policy content..."
                  style={{ minHeight: '500px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

